module.exports = __webpack_public_path__ + "img/P150T_weapon_75.ac1487b4.png";